import { render } from "./ModulesListScreen.vue?vue&type=template&id=52cd7017"
import script from "./ModulesListScreen.vue?vue&type=script&lang=js"
export * from "./ModulesListScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__